import React, { ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  eventId: string | undefined;
  error: Error | null;
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props) {
    super(props);
    this.state = { hasError: false, eventId: undefined, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Sentry.withScope(scope => {
    //   scope.setExtras(errorInfo);
    //   const eventId = Sentry.captureException(error);
    //   this.setState({ eventId });
    // });
  }

  render() {
    if (this.state.hasError) {
      const devMode = process.env.NODE_ENV === 'development';

      if (devMode) {
        return (
          <div
            style={{
              padding: 24,
              maxWidth: 720,
              margin: '0 auto',
              minHeight: '40vh',
              fontFamily: 'system-ui, sans-serif',
            }}
          >
            <h2 style={{ marginTop: 0 }}>Something went wrong</h2>
            {this.state.error?.message && (
              <pre
                style={{
                  whiteSpace: 'pre-wrap',
                  fontSize: 12,
                  background: '#f3f4f6',
                  padding: 16,
                  borderRadius: 8,
                  overflow: 'auto',
                }}
              >
                {this.state.error.message}
              </pre>
            )}
            <p style={{ color: '#6b7280', fontSize: 14 }}>
              See the browser console for the full stack trace.
            </p>
          </div>
        );
      }

      return (
        <div
          style={{
            display: 'flex',
            width: '100vw',
            minHeight: '100vh',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#1083c6',
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: 8,
              padding: 24,
              maxWidth: 400,
              boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
            }}
          >
            <p style={{ margin: 0, fontSize: 16 }}>Oops, something went wrong!</p>
            <p style={{ marginTop: 12, color: '#666', fontSize: 14 }}>
              We&apos;ve been notified, but you can send more information below.
            </p>
            <button
              type="button"
              style={{
                marginTop: 16,
                padding: '8px 16px',
                background: '#1083c6',
                color: '#fff',
                border: 'none',
                borderRadius: 4,
                cursor: 'pointer',
              }}
            >
              Send feedback
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
